import React from 'react';
import GenericMenu from './source/GenericMenuProject';
import { STORAGE_MENU, STORAGE_SECTION } from './constants/menuStructureProject';

export default function StorageMenu(props) {
  return (
    <GenericMenu
      menuConfig={STORAGE_MENU}
      sectionsMap={STORAGE_SECTION}
      propsRouter={props}
    />
  );
}
//  <Card arr={state.consumables} name='Расходные материалы' /> 
//   consumables:
//     { to: str + '/storage/consumables', primary: 'Список', disabled: true },
//     { to: str + '/storage/consumables/removal', primary: 'Документы списания', disabled: true },
//     { to: str + '/storage/consumables/removal/add', primary: 'Списать', disabled: true },
//   ]
//      <Card arr={state.equipment} name={'Оборудование'} />
//          equipment: [
//     { to: str + '/storage/equipment', primary: 'Остатки на складе' },
//     { to: str + '/storage/equipment/dynamics', primary: 'Расходы' },
//     { to: str + '/storage/equipment/removal', primary: 'Документы списания' },
//     { to: str + '/storage/equipment/removal/add', primary: 'Списать материалы' },
//   ],
//     <Card arr={state.arenda} name={'Аренда'} />
//       // arenda: [
//   //   { to: str + '/storage/arenda', primary: 'Склад', disabled: true },
//   // ],